module.exports = __webpack_public_path__ + "static/img/minibagsman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/minibagsman.jpg
// module id = a5jL
// module chunks = 1